export function exportToCsv(
  filename: string,
  headers: string[],
  rows: (string | number | null)[][]
): void {
  const escape = (v: string | number | null) =>
    v === null || v === undefined ? "" : `"${String(v).replace(/"/g, '""')}"`;
  const lines = [headers.map(escape).join(","), ...rows.map((r) => r.map(escape).join(","))];
  const csv = lines.join("\n");
  if (typeof window === "undefined") return;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
